/* =====================================================================
   HOOPSTARS — tiroir panier « HS · Panier » (sections/hs-cart.liquid)
   - Le contenu est rendu par Shopify (Section Rendering API) : titres,
     prix et remises toujours justes, dans la langue du client.
   - Cadeau mystère ajouté / retiré automatiquement selon le seuil.
   - Quantités, taille, suggestions, code promo, note de commande.
   ===================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URL_ADD = ROOT + 'cart/add.js';
  var URL_CHANGE = ROOT + 'cart/change.js';
  var URL_UPDATE = ROOT + 'cart/update.js';
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var KEY_BLOCKED = 'hs-cart-gift-blocked';
  var KEY_FAILED = 'hs-cart-gift-failed';

  var queue = Promise.resolve();
  var busy = 0;
  var pending = null;
  var editorSelected = false;
  var opener = null;
  var noteTimer = null;
  var closeTimer = null;
  var lastRender = Date.now();
  var knownCodes = null;

  /* ---------- Utilitaires ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function lc(s) { return String(s == null ? '' : s).toLowerCase(); }
  function esc(s) { return window.CSS && window.CSS.escape ? window.CSS.escape(s) : String(s); }
  function store(key, val) {
    try {
      if (val === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, val);
    } catch (e) { /* stockage indisponible */ }
  }
  function stored(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function rootEl() { return $('[data-hs-cart-section]'); }
  function sid() { var r = rootEl(); return r ? r.getAttribute('data-hs-cart-section') : null; }
  function dlg() { var r = rootEl(); return r ? $('dialog[data-hs-cart]', r) : null; }
  function inner() { var d = dlg(); return d ? $('[data-hs-cart-inner]', d) : null; }
  function onCartPage() {
    var m = document.getElementById('MainContent');
    return !!(m && /^cart/.test(m.getAttribute('data-template') || ''));
  }
  function autoOpen() { var r = rootEl(); return !r || r.getAttribute('data-auto-open') !== 'false'; }

  function readState() {
    var box = inner();
    var el = box && $('script[data-hs-cart-state]', box);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function currentCodes(st) {
    var out = [];
    ((st && st.codes) || []).concat(knownCodes || []).forEach(function (c) {
      if (c && out.map(lc).indexOf(lc(c)) === -1) out.push(c);
    });
    return out;
  }

  /* ---------- Ouverture / fermeture ---------- */
  function setExpanded(on) {
    $$('[data-hs-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }

  function open() {
    var d = dlg();
    if (!d || onCartPage()) return false;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    d.classList.remove('is-closing');
    if (!d.open) {
      opener = document.activeElement;
      try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
      setExpanded(true);
    }
    document.documentElement.classList.add('hs-lock');
    return true;
  }

  function close(now) {
    var d = dlg();
    if (!d || !d.open) return;
    function finish() {
      closeTimer = null;
      d.classList.remove('is-closing');
      if (d.open) { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
      document.documentElement.classList.remove('hs-lock');
      setExpanded(false);
      var o = opener;
      opener = null;
      if (o && o.focus && document.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) { /* rien */ } }
    }
    if (now || reduceMotion.matches) { finish(); return; }
    if (closeTimer) return;
    d.classList.add('is-closing');
    closeTimer = setTimeout(finish, 180);
  }

  /* ---------- Rendu ---------- */
  function focusKey(el) {
    var k = el && el.closest ? el.closest('[data-hs-focus]') : null;
    return k ? k.getAttribute('data-hs-focus') : null;
  }

  function notice(msg, isError) {
    var box = inner();
    var el = box && $('[data-hs-cart-notice]', box);
    if (!el || !msg) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    clearTimeout(notice.t);
    notice.t = setTimeout(function () { if (document.contains(el)) el.hidden = true; }, 7000);
  }

  function render(html) {
    var cur = inner();
    if (!cur || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = $('[data-hs-cart-inner]', doc);
    if (!next) return false;

    var active = document.activeElement;
    var hadFocus = !!(active && cur.contains(active));
    var fk = hadFocus ? focusKey(active) : null;
    var body = $('[data-hs-cart-body]', cur);
    var scroll = body ? body.scrollTop : 0;
    var rails = {};
    $$('[data-hs-rail]', cur).forEach(function (r) { rails[r.getAttribute('data-hs-rail')] = r.scrollLeft; });
    var opened = {};
    $$('details[data-hs-keep-open]', cur).forEach(function (el) { opened[el.getAttribute('data-hs-keep-open')] = el.open; });
    var kept = {};
    $$('[data-hs-preserve]', cur).forEach(function (el) { kept[el.getAttribute('data-hs-preserve')] = el.value; });
    var oldFill = $('[data-hs-fill]', cur);
    var oldW = oldFill ? oldFill.style.width : null;

    var node = document.importNode(next, true);
    cur.parentNode.replaceChild(node, cur);
    lastRender = Date.now();

    $$('details[data-hs-keep-open]', node).forEach(function (el) {
      if (opened[el.getAttribute('data-hs-keep-open')] === true) el.open = true;
    });
    $$('[data-hs-preserve]', node).forEach(function (el) {
      var k = el.getAttribute('data-hs-preserve');
      if (Object.prototype.hasOwnProperty.call(kept, k)) el.value = kept[k];
    });
    var nb = $('[data-hs-cart-body]', node);
    if (nb) nb.scrollTop = scroll;
    $$('[data-hs-rail]', node).forEach(function (r) {
      var k = r.getAttribute('data-hs-rail');
      if (rails[k] != null) r.scrollLeft = rails[k];
    });
    var fill = $('[data-hs-fill]', node);
    if (fill && oldW && oldW !== fill.style.width && !reduceMotion.matches) {
      var target = fill.style.width;
      fill.style.transition = 'none';
      fill.style.width = oldW;
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = target;
    }
    if (hadFocus) {
      var f = fk ? $('[data-hs-focus="' + esc(fk) + '"]', node) : null;
      var target2 = f && !f.disabled ? f : node;
      try { target2.focus({ preventScroll: true }); } catch (e) { target2.focus(); }
    }
    if (pending) { notice(pending.msg, pending.error); pending = null; }
    return true;
  }

  function emit(st) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: {}, sourceId: 'hs-cart', data: { source: 'hs-cart', itemCount: st.count } }
    }));
  }

  function refresh() {
    var id = sid();
    if (!id) return Promise.resolve(null);
    return fetch(ROOT + '?sections=' + encodeURIComponent(id), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
      .then(function (data) { render(data && data[id]); return readState(); })
      .catch(function () { return readState(); });
  }

  /* ---------- Requêtes panier (une à la fois) ---------- */
  function setBusy(on) {
    busy = Math.max(0, busy + (on ? 1 : -1));
    var d = dlg();
    if (d) d.classList.toggle('is-busy', busy > 0);
  }

  function run(task) {
    var p = queue.then(function () { setBusy(true); return task(); });
    function done() { setBusy(false); }
    queue = p.then(done, done);
    return p;
  }

  function post(url, body, withSections) {
    var id = sid();
    if (withSections !== false && id) body.sections = id;
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Oups, ça n\'a pas marché. Réessaie.');
          err.data = data;
          throw err;
        }
        if (data && Array.isArray(data.discount_codes)) {
          knownCodes = data.discount_codes.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        }
        return data;
      });
    });
  }

  function apply(data) {
    var id = sid();
    var html = data && data.sections && id ? data.sections[id] : null;
    var p = html && render(html) ? Promise.resolve(readState()) : refresh();
    return p.then(function (st) { if (st) emit(st); return st; });
  }

  /* ---------- Cadeau mystère ---------- */
  function syncGift(st, depth) {
    depth = depth || 0;
    if (!st || DESIGN || depth > 3) return Promise.resolve(st);
    var lines = st.lines || [];
    var gifts = lines.filter(function (l) { return l.gift; });
    var updates = {};
    var need = false;
    lines.forEach(function (l) { if (l.legacy) { updates[l.key] = 0; need = true; } });

    var sig = (st.codes || []).map(lc).sort().join('|');
    var blocked = stored(KEY_BLOCKED);
    if (blocked !== null && blocked !== sig) { store(KEY_BLOCKED, null); blocked = null; }
    var want = !!(st.giftAuto && st.giftVariant && st.eligible >= st.giftN);

    if (gifts.length) {
      if (!want) {
        gifts.forEach(function (l) { updates[l.key] = 0; });
        need = true;
      } else if (!st.giftApplied) {
        // Le cadeau n'est pas offert (code promo non cumulable) : on le retire
        gifts.forEach(function (l) { updates[l.key] = 0; });
        need = true;
        store(KEY_BLOCKED, sig);
        if (st.msgBlocked) pending = { msg: st.msgBlocked, error: false };
      } else {
        gifts.forEach(function (l, i) {
          var q = i === 0 ? 1 : 0;
          if (l.qty !== q) { updates[l.key] = q; need = true; }
        });
      }
    }

    if (need) {
      return post(URL_UPDATE, { updates: updates })
        .then(apply)
        .then(function (s2) { return syncGift(s2, depth + 1); });
    }
    if (want && !gifts.length && blocked === null && stored(KEY_FAILED) !== String(st.giftVariant)) {
      return post(URL_ADD, { items: [{ id: Number(st.giftVariant), quantity: 1, properties: { _hs_gift: '1' } }] })
        .then(apply)
        .then(function (s2) { return syncGift(s2, depth + 1); })
        .catch(function () { store(KEY_FAILED, String(st.giftVariant)); return st; });
    }
    return Promise.resolve(st);
  }

  /* ---------- Actions ---------- */
  function lineByKey(key) {
    var box = inner();
    return box ? $('[data-hs-line][data-key="' + esc(key) + '"]', box) : null;
  }
  // Les clés de ligne changent quand Shopify recalcule les remises :
  // on retrouve la ligne au moment d'agir (clé, sinon même variante).
  function findLine(key) {
    var line = lineByKey(key);
    if (line) return line;
    var vid = String(key).split(':')[0];
    var box = inner();
    if (!box) return null;
    return $$('[data-hs-line]', box).filter(function (l) {
      return String(l.getAttribute('data-key') || '').split(':')[0] === vid && !l.classList.contains('hs-cart__line--gift');
    })[0] || null;
  }
  function lineError(key, msg) {
    var line = findLine(key);
    var el = line && $('[data-hs-line-error]', line);
    if (el && msg) { el.textContent = msg; el.hidden = false; }
    else if (msg) notice(msg, true);
  }

  function changeLine(key, delta, absolute) {
    var el = lineByKey(key);
    if (el) el.classList.add('is-busy');
    return run(function () {
      var line = findLine(key);
      if (!line) return refresh();
      var k = line.getAttribute('data-key');
      var cur = parseInt(line.getAttribute('data-qty'), 10) || 0;
      var qty = absolute != null ? absolute : Math.max(cur + delta, 0);
      return post(URL_CHANGE, { id: k, quantity: qty })
        .then(apply)
        .then(function (st) { return syncGift(st); })
        .catch(function (err) { return refresh().then(function () { lineError(k, err.message); }); });
    });
  }

  function changeVariant(sel) {
    var line0 = sel.closest('[data-hs-line]');
    if (!line0) return;
    var key = line0.getAttribute('data-key');
    var newId = Number(sel.value);
    var props = {};
    try { props = JSON.parse(sel.getAttribute('data-props') || '{}') || {}; } catch (e) { props = {}; }
    function item(id, qty) {
      var it = { id: id, quantity: qty };
      if (props && typeof props === 'object' && Object.keys(props).length) it.properties = props;
      return it;
    }
    line0.classList.add('is-busy');
    return run(function () {
      var line = findLine(key);
      if (!line) return refresh();
      var k = line.getAttribute('data-key');
      var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;
      var oldId = Number(String(k).split(':')[0]);
      if (!newId || oldId === newId) return refresh();
      var removed = false;
      // On retire d'abord (clé encore valable), puis on ajoute la nouvelle taille
      return post(URL_CHANGE, { id: k, quantity: 0 }, false)
        .then(function () { removed = true; return post(URL_ADD, { items: [item(newId, qty)] }); })
        .then(apply)
        .then(function (st) { return syncGift(st); })
        .catch(function (err) {
          var back = removed ? post(URL_ADD, { items: [item(oldId, qty)] }, false).catch(function () { return null; }) : Promise.resolve();
          return back.then(refresh).then(function () { notice(err.message, true); });
        });
    });
  }

  function addProduct(btn) {
    var card = btn.closest('[data-hs-card]');
    var sel = card ? $('[data-hs-add-select]', card) : null;
    var vid = btn.getAttribute('data-hs-add') || (sel ? sel.value : '');
    if (!vid) {
      if (sel) {
        sel.classList.remove('is-error');
        void sel.offsetWidth;
        sel.classList.add('is-error');
        try { sel.focus(); if (sel.showPicker) sel.showPicker(); } catch (e) { /* rien */ }
      }
      return;
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    return run(function () {
      return post(URL_ADD, { items: [{ id: Number(vid), quantity: 1 }] })
        .then(apply)
        .then(function (st) {
          var b = $('[data-hs-cart-body]', inner() || document);
          if (b) { try { b.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' }); } catch (e) { b.scrollTop = 0; } }
          return syncGift(st);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          notice(err.message, true);
        });
    });
  }

  function codeBox() { var box = inner(); return box ? $('[data-hs-code]', box) : null; }
  function codeMessage(msg, isError) {
    var box = codeBox();
    var el = box && $('[data-hs-code-msg]', box);
    if (!el) { if (msg) notice(msg, isError); return; }
    if (!msg) { el.hidden = true; return; }
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    if (box.tagName === 'DETAILS') box.open = true;
  }

  function applyCode(form) {
    var input = $('input[name="code"]', form);
    var code = input ? String(input.value || '').trim() : '';
    if (!code) { if (input) input.focus(); return; }
    var box = form.closest('[data-hs-code]');
    var errText = (box && box.getAttribute('data-error')) || 'Ce code n\'est pas valable.';
    var errGift = (box && box.getAttribute('data-error-gift')) || errText;
    var shipText = (box && box.getAttribute('data-ship')) || '';
    var codes = currentCodes(readState());
    if (codes.map(lc).indexOf(lc(code)) > -1) { input.value = ''; return; }
    codeMessage('');
    return run(function () {
      return post(URL_UPDATE, { discount: codes.concat([code]).join(',') })
        .then(function (data) {
          var hit = null;
          ((data && data.discount_codes) || []).forEach(function (dc) { if (lc(dc.code) === lc(code)) hit = dc; });
          if (!hit || !hit.applicable) {
            return post(URL_UPDATE, { discount: codes.join(',') })
              .then(apply)
              .then(function (s2) {
                var hasGift = !!(s2 && (s2.lines || []).some(function (l) { return l.gift; }));
                codeMessage(hasGift ? errGift : errText, true);
                return syncGift(s2);
              });
          }
          return apply(data).then(function (s2) {
            var shown = !!(s2 && (s2.codes || []).map(lc).indexOf(lc(code)) > -1);
            if (!shown && shipText) codeMessage(shipText, false);
            return syncGift(s2);
          });
        })
        .catch(function (err) { codeMessage(err.message || errText, true); });
    });
  }

  function removeCode(code) {
    var rest = currentCodes(readState()).filter(function (c) { return lc(c) !== lc(code); });
    return run(function () {
      return post(URL_UPDATE, { discount: rest.join(',') })
        .then(apply)
        .then(function (st) { return syncGift(st); })
        .catch(function (err) { notice(err.message, true); });
    });
  }

  /* ---------- Événements ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var trigger = t.closest('[data-hs-cart-open]');
    if (trigger) {
      if (open()) {
        e.preventDefault();
        if (Date.now() - lastRender > 60000) {
          run(function () { return refresh().then(function (st) { return syncGift(st); }); }).catch(function () { /* rien */ });
        }
      }
      return;
    }

    var d = dlg();
    if (!d || !d.contains(t)) return;
    if (t === d || t.closest('[data-hs-cart-close]')) { close(); return; }

    var qb = t.closest('[data-hs-qty]');
    if (qb) {
      var line = qb.closest('[data-hs-line]');
      if (!line || qb.disabled) return;
      changeLine(line.getAttribute('data-key'), parseInt(qb.getAttribute('data-hs-qty'), 10) || 0);
      return;
    }
    var rm = t.closest('[data-hs-remove]');
    if (rm) {
      var l2 = rm.closest('[data-hs-line]');
      if (l2) changeLine(l2.getAttribute('data-key'), 0, 0);
      return;
    }
    var add = t.closest('[data-hs-add]');
    if (add) { addProduct(add); return; }
    var crm = t.closest('[data-hs-code-remove]');
    if (crm) { removeCode(crm.getAttribute('data-hs-code-remove')); return; }
    var sc = t.closest('[data-hs-scroll]');
    if (sc) {
      var up = sc.closest('[data-hs-upsell]');
      var rail = up && $('[data-hs-rail]', up);
      if (rail) {
        var dir = parseInt(sc.getAttribute('data-hs-scroll'), 10) || 1;
        rail.scrollBy({ left: dir * Math.max(rail.clientWidth * 0.8, 150), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.matches('select[data-hs-variant]')) { changeVariant(t); return; }
    if (t.matches('select[data-hs-add-select]')) t.classList.remove('is-error');
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.matches('[data-hs-cart-note]')) return;
    var v = t.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { post(URL_UPDATE, { note: v }, false).catch(function () { /* rien */ }); }, 500);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof Element)) return;
    if (f.matches('[data-hs-code-form]')) { e.preventDefault(); applyCode(f); }
  });

  // Échap : on ferme avec l'animation
  document.addEventListener('cancel', function (e) {
    var d = dlg();
    if (d && e.target === d) { e.preventDefault(); close(); }
  }, true);
  document.addEventListener('close', function (e) {
    var d = dlg();
    if (d && e.target === d) {
      d.classList.remove('is-closing');
      document.documentElement.classList.remove('hs-lock');
      setExpanded(false);
    }
  }, true);

  // Ajouts faits ailleurs (fiche produit, ajout rapide, applis) : on recharge le tiroir
  document.addEventListener('cart:update', function (e) {
    var d = (e && e.detail && e.detail.data) || {};
    if (d.source === 'hs-cart' || !dlg() || onCartPage()) return;
    var id = sid();
    var html = d.sections && id ? d.sections[id] : null;
    run(function () {
      var p = html && render(html) ? Promise.resolve(readState()) : refresh();
      return p.then(function (st) { return syncGift(st); });
    }).catch(function () { /* rien */ });
    if (d.source === 'product-form-component' && autoOpen()) open();
  });

  // Retour arrière (cache du navigateur) : le panier a pu changer
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && dlg() && !onCartPage()) {
      run(function () { return refresh().then(function (st) { return syncGift(st); }); }).catch(function () { /* rien */ });
    }
  });

  /* ---------- Éditeur de thème ---------- */
  function mine(e) {
    var id = sid();
    if (e.detail && id && e.detail.sectionId === id) return true;
    var t = e.target;
    return !!(t && t.querySelector && (t.matches('[data-hs-cart-section]') || t.querySelector('[data-hs-cart-section]')));
  }
  document.addEventListener('shopify:section:select', function (e) { if (mine(e)) { editorSelected = true; open(); } });
  document.addEventListener('shopify:section:deselect', function (e) { if (mine(e)) { editorSelected = false; close(true); } });
  document.addEventListener('shopify:block:select', function (e) {
    if (!mine(e)) return;
    editorSelected = true;
    open();
    var el = e.target;
    if (el && el.scrollIntoView) setTimeout(function () { el.scrollIntoView({ block: 'nearest' }); }, 80);
  });
  document.addEventListener('shopify:section:load', function (e) { if (mine(e) && editorSelected) setTimeout(open, 0); });
  document.addEventListener('shopify:section:unload', function (e) { if (mine(e)) document.documentElement.classList.remove('hs-lock'); });

  /* ---------- Démarrage ---------- */
  function boot() {
    if (!dlg() || onCartPage()) return;
    var st = readState();
    if (st) run(function () { return syncGift(st); }).catch(function () { /* rien */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.HSCart = {
    open: open,
    close: close,
    refresh: function () { return run(function () { return refresh().then(function (st) { return syncGift(st); }); }); },
    sectionId: sid
  };
})();